import React, { useState, useContext, useEffect } from "react";
import "./LoginPage.css";
import { Link, useNavigate } from "react-router-dom";

import Cookies from "js-cookie";
import { Context } from "../../../../utils/context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import ModalLogin from "../../../common/ModalLogin";
import { dismissExpiredNotice, readExpiredNotice } from "../../../../utils/auth";
const LoginPage = () => {
  const { postData, setSignin, } =
    useContext(Context);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [modalShow, setModalShow] = React.useState(false);
  const [errors, setErrors] = useState({});
  const [showErrorModal, setShowErrorModal] = useState();
  const [Hide, setHide] = useState(false);
  // shown once when the user was sent here because the session expired
  const [sessionExpired] = useState(readExpiredNotice);
  useEffect(() => {
    dismissExpiredNotice();
  }, []);

  const validateForm = () => {
    let errors = {};

    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    if (!formData.email.trim()) {
      errors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      errors.email = "Enter a valid email address";
    }

    if (!formData.password.trim()) {
      errors.password = "Password is required";
    }

    return errors;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      try {
        const response = await postData("/auth/login", formData);

        if (response.success) {
          setSignin(response.success);
                   Cookies.set("tradex_security", response.data?.token, {
            expires: 2,
          });

          navigate("/dashboard");
        } else {
          setShowErrorModal(response);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };

  const errorStyle = {
    color: "var(--danger-700)",
    marginLeft: "5px",
  };

  return (
    <>
      <section className="Login">
        <aside className="login-brand" aria-hidden="true">
          <div className="login-brand-inner">
            <span className="login-brand-mark">B</span>
            <h1>BlueChart</h1>
            <p>Manage investors, payments and reports in one place.</p>
          </div>
        </aside>
        <div className="login-panel">
          <div className="card text-center login-card">
            <div className="text-holder-login">
              <h2>Login Here</h2>
              <p className="login-sub">Sign in to your admin account</p>
              {sessionExpired && (
                <p className="login-notice" role="status">
                  Your session has expired. Please log in again.
                </p>
              )}

              {showErrorModal?.success ? (
                <></>
              ) : (
                <>
                  <span style={errorStyle} role="alert">
                    {showErrorModal?.message}
                  </span>
                </>
              )}
              <form onSubmit={handleSubmit}>
                <div className="mb-3 loginForm_txt_main">
                  <label htmlFor="login-email" className="form-label loginForm_txt">
                    Email
                  </label>
                  <input
                    type="email"
                    className="form-control form-control-email"
                    id="login-email"
                    aria-describedby="emailHelp"
                    aria-invalid={errors.email ? "true" : undefined}
                    placeholder="Enter Email"
                    name="email"
                    autoComplete="username"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  {errors.email && (
                    <span style={errorStyle} role="alert">
                      {errors.email}
                    </span>
                  )}
                </div>
                <div className="loginForm_txt_main">
                  <label
                    htmlFor="login-password"
                    className="form-label loginForm_txt"
                  >
                    Password
                  </label>
                  <div className="login-password">
                    <input
                      type={Hide ? "text" : "password"}
                      className="form-control form-control-email"
                      id="login-password"
                      placeholder="Password"
                      aria-describedby="basic-addon2"
                      aria-invalid={errors.password ? "true" : undefined}
                      name="password"
                      autoComplete="current-password"
                      value={formData.password}
                      onChange={handleChange}
                    />
                    <button
                      type="button"
                      className="login_eye_icon"
                      onClick={() => setHide(!Hide)}
                      aria-label={Hide ? "Hide password" : "Show password"}
                    >
                      <FontAwesomeIcon icon={Hide ? faEye : faEyeSlash} />
                    </button>
                  </div>
                </div>
                {errors.password && (
                  <span style={errorStyle} role="alert">
                    {errors.password}
                  </span>
                )}

                <Link to="/">
                  <button
                    type="submit"
                    onClick={handleSubmit}
                    className="btn sign-in-button text-center"
                  >
                    Login
                  </button>
                </Link>
              </form>
            </div>
          </div>
        </div>

        <ModalLogin show={modalShow} onHide={() => setModalShow(false)} />
      </section>
    </>
  );
};

export default LoginPage;
